import { render, staticRenderFns } from "./computerScience.vue?vue&type=template&id=3501b672&"
import script from "./computerScience.vue?vue&type=script&lang=js&"
export * from "./computerScience.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports